import UpcomingCourses from "./components/UpcomingCourses"

let module = "frontend"

export default [
  {
    path: "upcoming-courses",
    component: UpcomingCourses,
    props: true,
    meta: { module: module, permissions: ["all"] }
  }
]
